import { call, put, select } from 'redux-saga/effects'

import actions from 'actions'
import api from 'services'
import { fetchData, fetchEntity } from 'utils/sagas'
import { getCurrentPartnerId, getIdentityPartners, getIdentityPortalUser } from 'selectors/settings'
import { updateCurrentPartnerSettings } from 'actions/settings'
import Raven from 'utils/raven'

// entity fetchers
const fetchPartnerSettings = fetchEntity.bind(null, actions.partnerSettings, api.fetchPartnerSettings)
const fetchSettings = fetchData.bind(null, actions.settings, api.fetchSettings)
const fetchPortalUsers = fetchData.bind(null, actions.portalUserSearch, api.fetchPortalUsers)
const fetchPartners = fetchData.bind(null, actions.partnerSearch, api.fetchPartners)

// sagas
export function* loadCurrentPartnerSettings() {
  const partnerId = parseInt(yield select(getCurrentPartnerId), 10)
  const user = yield select(getIdentityPortalUser)
  const identityPartners = yield select(getIdentityPartners)

  // only load partner settings if identity has access to the partner
  if (identityPartners.indexOf(partnerId) !== -1 || (user && user.isStaffUser)) {
    yield call(fetchPartnerSettings, partnerId)
  }
}

export function* loadSettings() {
  // fetch settings and then update the partner settings
  yield call(fetchSettings)
  yield put(updateCurrentPartnerSettings())
}

export function* searchPortalUsers({ query }) {
  yield call(fetchPortalUsers, query)
}

export function* searchPartners({ query }) {
  yield call(fetchPartners, query)
}


export function* setUserContext() {
  const user = yield select(getIdentityPortalUser)
  yield call([Raven, Raven.setUserContext], user)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/settings/settings-sagas.js
 **/